import { NotificationPayload, NotificationsContext } from 'common/providers/NotificationProvider/NotificationProvider';
import { useContext } from 'react';

export const useNotification = (): ((payload: NotificationPayload) => void) => {
  const { addNotification } = useContext(NotificationsContext);

  return addNotification;
};
